import React from "react";
import { HeroSection } from "../components/HeroSection.tsx";
import { AboutSection } from "../components/AboutSection.tsx";
import { LocationSection } from "../components/LocationSection.tsx";
import { ServicesSection } from "../components/ServicesSection.tsx";
import { SmartCarousel } from "../components/SmartCarousel.tsx";
import { PricingSection } from "../components/PricingSection.tsx";
import { ScrollToTopButton } from "../components/ScrollToTopButton.tsx";
import { ReviewsSection } from "../components/ReviewsSection.tsx";

interface HomePageProps {
  onOpenBookingDialog: () => void;
}

export const HomePage: React.FC<HomePageProps> = ({ onOpenBookingDialog }) => {
  return (
    <>
      {/* Hero Section */}
      <HeroSection onOpenBookingDialog={onOpenBookingDialog} />

      {/* About Section */}
      <AboutSection />

      {/* Location Section */}
      <LocationSection />

      {/* Services Section */}
      <ServicesSection />
      
      {/* Smart Carousel */}
      <SmartCarousel />

      {/* Reviews Section */}
      <ReviewsSection />
      {/*  */}

      {/* Pricing Section */}
      <PricingSection />

      {/* Scroll to top button */}
      <ScrollToTopButton />
    </>
  );
};
